<template>
  <div>
    <sd-header></sd-header>
    <div class="center_wrap">
      <div class="side_menu">
        <ul class="side_ul" v-for="group in pageGroup">
          <li v-for="page in group">
            <router-link v-if="page.name" :class="{ on: $route.name == page.name }" :to="{ name: page.name }"
              >{{ page.title }}
              <span v-if="page.amount && amount != 0">( {{ amount }} )</span>
            </router-link>
            <a class="title" v-if="!page.name">{{ page.title }}</a>
          </li>
        </ul>
      </div>
    </div>
    <router-view></router-view>
    <sd-footer></sd-footer>
  </div>
</template>

<script type="es6">
  import { mapState, mapActions , mapGetters} from 'vuex'
  import { util } from '../service/util'
  import sdHeader from '../components/sdHeader'
  import sdFooter from '../components/sdFooter'
  let API = util.api([
      'LOGIN',
      'GETINFOCOUNT'
    ]);
  export default {
      name: 'base-view',
      components: { sdHeader,sdFooter },
      data () {
        return {
            // amount:'',
            res : '',
            oldSearchStr:'',
            pageGroup: [
                [
                    {name:'HomeView',title:'我的主页'}
                ],
                [
                    { name:'',title:'订单中心'},
                    { name: 'OrderView',title: '我的订单'},
                    { name: 'CouponView',title: '我的优惠券'}
                ],
                [
                    {name:'',title:'财务中心'},
                    { name: 'RechargeView',title: '充值' },
                    { name: 'PayRecord', title: '支付记录'},
                    // { name: 'ChargeRecord', title: '充值记录'},
                    { name: 'MyInvoiceView',title: '我的发票'},
                    { name: 'AddressView',title: '发票地址管理'},
                ],
                [
                    { name:'',title:'客户服务'},
                    { name: 'CollectView',title: '我的收藏' },
                    { name: 'MessageView',title: '我的消息',amount:true},
                    { name: 'EnterpriseView',title: '企业认证'},
                    { name: 'IdentityView',title: '身份认证'},
                ],
                [
                    { name:'',title:'设置'},
                    { name: 'InfoView',title: '基本信息' },
                    { name: 'ResetView',title: '修改密码'},
                    // { name: 'WithdrawRecord', title: '提现记录'}
                ],
//                 [
//                     {name:'',title:'推荐返利'},
//                     {name:'RebateIntro',title:'介绍'},
//                     {name:'RecommendStat',title:'推荐统计'},
// //                    {name:'RebateStat',title:'返利统计'}
//                 ]
            ]
        }
      },
      computed: {
        ...mapState({
            userInfo : state => state.common.userInfo,
            log : state => state.common.log,
            amount   : state => state.common.amount
          }),
      },
      methods: {
        toSearchPage() {
            window.open('/search/result.html?oldSearchStr='+this.oldSearchStr);
        },
        getAmount(){
           this.$store.dispatch('updateMessageAmount');
        },
      },
      created() {
          let _this = this;
          this.$store.dispatch('getUserInfo')
              .then( res => {
                  _this.getAmount();
              })
      },
      watch: {
         // 路由改变刷新次数
         $route(nv) {
            this.getAmount();
         }
      },
      mounted(){

      }
    }
</script>

<style></style>



// WEBPACK FOOTER //
// BaseView.vue?136b4118